import { gsap, ScrollTrigger } from '../global/gsap';

const initHomeGallery = (section) => {
    const images = section.querySelectorAll('.js-image');
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 2.5
        }
    });

    if (images) {
        gsap.set(images[0], {
            yPercent: -40,
            xPercent: 60
        });
        gsap.set(images[1], {
            yPercent: -60,
            xPercent: -150
        });
        gsap.set(images[2], {
            yPercent: 75,
            xPercent: 47
        });

        tl.to(images, {
            yPercent: 0,
            xPercent: 0
        });
    }
};

export default initHomeGallery;
